import { render, staticRenderFns } from "./VTooltipIconV2.vue?vue&type=template&id=ccecada6"
import script from "./VTooltipIconV2.vue?vue&type=script&lang=js"
export * from "./VTooltipIconV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports